// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3w3Uo","options":"AnswerScale_options__39AeB","selected":"AnswerScale_selected__G7fEg"};